import { FlowChartNode } from '../../../angie-shared/components/lu-flow-chart/models/flow.model';
import { ProgressionNode } from '../../learning-journey-progression/models/learning-journey-progression.model';
import { IdNameMap, LJNode, LJNodeData, WorkflowContainerType, WorkflowStatus } from '../models/learning-journey.model';

// Mapping data from canvas to backend structure (root)
export function fromWorkflowRootToLJRootNode(flowChartNode: FlowChartNode<LJNodeData>): LJNode {
	return {
		ui_id: flowChartNode.id,
		container: { ...flowChartNode.data.container, type: flowChartNode.type },
		nodes: mapChildrenToLJNodes(flowChartNode.children)
	};
}

// Mapping data from canvas to backend structure (children)
export function mapChildrenToLJNodes(children: FlowChartNode<LJNodeData>[]): LJNode[] {
	return children.map(child => {
		if (
			[WorkflowContainerType.COURSE, WorkflowContainerType.CERTIFICATE].includes(child?.type as WorkflowContainerType)
		) {
			delete child?.data?.container?.definition?.name;
		}
		let ljNode: LJNode = {
			container: { ...child.data.container, type: child.type },
			ui_id: child.id,
			nodes: []
		};
		if (!child?.children?.length) return ljNode;
		ljNode.nodes = mapChildrenToLJNodes(child.children);
		return ljNode;
	});
}

// Mapping data from backend to canvas structure (root)
export function fromLJRootToWorkflowRootNode(
	ljNode: LJNode,
	workflowStatus?: WorkflowStatus,
	courses?: IdNameMap,
	certificates?: IdNameMap,
	contentNameError?: string
): FlowChartNode<LJNodeData> {
	return {
		id: ljNode.ui_id,
		type: ljNode.container.type,
		data: {
			container: ljNode.container,
			workflowStatus
		},
		children: mapLJToChildrenNodes(ljNode.nodes, workflowStatus, courses, certificates, contentNameError)
	};
}

// Mapping data from backend to canvas structure (children)
export function mapLJToChildrenNodes(
	nodes: LJNode[],
	workflowStatus?: WorkflowStatus,
	courses?: IdNameMap,
	certificates?: IdNameMap,
	contentNameError?: string
): FlowChartNode<LJNodeData>[] {
	return nodes.map(node => {
		let flowChartNode: FlowChartNode<LJNodeData> = {
			id: node.ui_id,
			type: node.container.type,
			data: {
				container: node.container,
				workflowStatus
			},
			children: []
		};

		// Adding name to the course nodes
		if (node.container.type === WorkflowContainerType.COURSE) {
			flowChartNode.data.container.definition.name = courses?.[node.container.definition.id] || contentNameError;
		}

		// Adding name to the certificate nodes
		if (node.container.type === WorkflowContainerType.CERTIFICATE) {
			flowChartNode.data.container.definition.name = certificates?.[node.container.definition.id] || contentNameError;
		}

		if (!node?.nodes?.length) return flowChartNode;
		flowChartNode.children = mapLJToChildrenNodes(node.nodes, workflowStatus, courses, certificates, contentNameError);
		return flowChartNode;
	});
}

export function getIdsOfType(nodes: (LJNode | ProgressionNode)[], type: WorkflowContainerType): number[] {
	const result: number[] = [];

	const collectIds = (nodes: (LJNode | ProgressionNode)[]) => {
		nodes?.forEach(node => {
			if (node.container.type === type) {
				result.push(node.container.definition.id);
			}
			if (node.nodes && node.nodes.length > 0) {
				collectIds(node.nodes);
			}
		});
	};

	collectIds(nodes);
	return result;
}
